exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backButton__button___i7_O_ {\n  border: none;\n  background-color: transparent;\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-left: -3px;\n  z-index: 1;\n  font-size: 15px;\n  font-weight: 600; }\n  .backButton__button___i7_O_ > img {\n    height: 12px;\n    margin-right: 8px; }\n", ""]);

// exports
exports.locals = {
	"button": "backButton__button___i7_O_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/ModulePage/MobileFooterButtons/BackButton/backButton.scss
// module id = 4710
// module chunks = 6